import { Container } from '@mui/material';
import useExplorePageStyles from '../useExplorePageStyles';

/**
 * VerticalPad component renders a vertical bar to serve as dynamic padding in a flex grid.
 */
const VerticalPad = () => {
  const { classes } = useExplorePageStyles();
  return (
    <div>
      <Container className={classes.verticalPad} disableGutters></Container>
    </div>
  );
};

export default VerticalPad;
